import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative inline-block w-10 mr-2 align-middle select-none" }
const _hoisted_2 = {
  for: "toggle",
  class: "text-md text-gray-700 dark:text-gray-300 cursor-pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        id: "toggle",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theme) = $event)),
        type: "checkbox",
        name: "toggle",
        "true-value": "dark",
        "false-value": "light",
        class: "toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-gray-300 border-4 appearance-none cursor-pointer",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTheme()))
      }, null, 544), [
        [_vModelCheckbox, _ctx.theme]
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("label", {
        for: "toggle",
        class: "toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
      }, null, -1))
    ]),
    _createElementVNode("label", _hoisted_2, " Enable " + _toDisplayString(_ctx.themeOpposite) + " mode ", 1)
  ]))
}